import StReportSdk from '@xfe/st-report-sdk';
import DeviceUtils from '@src/utils/device-utils';

let params = {};
if (DeviceUtils.isMobile()) {
  params = {
    projectIdentifier: 'jxsj2' /*项目标识: 如: jx3, 必须填写！！*/,
    eventTags: ['wjhg', 'mo'] /* 专题tags，最后一个 js4_xxxx_20181204 需要替换为埋点文档上的专题标识，必须填写！！ */,
    eventGroup: 'jxsj2_gdzh_mo_20190708'
  };
} else {
  params = {
    projectIdentifier: 'jxsj2' /*项目标识: 如: jx3, 必须填写！！*/,
    eventTags: ['wjhg', 'pc'] /* 专题tags，最后一个 js4_xxxx_20181204 需要替换为埋点文档上的专题标识，必须填写！！ */,
    eventGroup: 'jxsj2_gdzh_pc_20190708'
  };
}

export const stReportSdk = StReportSdk.getInstance(
  params,
  DEPLOY_ENV !== 'master' /* 是否开日志上报的 logger，默认是生产环境不开，平时开；想要关可以直接设为false */
);

export const report = ({
  eventName /* String 事件名 一般是英文 */,
  eventDescription /* String 事件描述 一般是中文 */,
  eventGroup /* String 事件组，一般只有一个，例如“webstat”，若有多个，则用空格隔开，注意是字符串不是数组哦 */,
  eventDataValue = {} /* String 事件数据*/,
  ...restProps /* 其他参数详见 sdk https://gitlab.xsjcs.cn/xfe/st-report-sdk 和 Wiki //wiki.xsjcs.cn/pages/viewpage.action?pageId=18068827 */
}) => {
  try {
    stReportSdk.report({
      eventName,
      eventDescription,
      eventDataValue,
      eventGroup,
      eventTags: params.eventTags,
      ...restProps
    });
  } catch (e) {
    // 为了能够继续往后走, 但是能够上报
    setTimeout(() => {
      throw e;
    });
  }
};



// WEBPACK FOOTER //
// ./src/$$tracker/report.js